"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.asyncInterleaveReady = void 0;

var _asyncInterleave = _interopRequireDefault(require("../$interleave/async-interleave"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

async function* _asyncInterleaveReady(_, canTakeAny) {
  let buffer;

  while (buffer = await canTakeAny()) yield await buffer.take();
}

const emptyOptions = {};
const asyncInterleaveReady = (0, _asyncInterleave.default)(_asyncInterleaveReady, emptyOptions);
exports.asyncInterleaveReady = asyncInterleaveReady;
var _default = asyncInterleaveReady;
exports.default = _default;